import { environment } from 'environments/environment';

/**
 * Public (session-less) authorizer endpoints, used by the "View Recipients"
 * page an authorizer reaches from the approval email. All three live under one
 * path on xas, so a single prefix covers them:
 *
 *   POST <prefix>/otp/:payment_id       { email }
 *   POST <prefix>/validate/:payment_id  { token, identifier }   -> JWT
 *   GET  <prefix>?page&limit&search     Authorization: <JWT>
 *
 * Kept in its own file so AuthInterceptor can allow-list them without pulling
 * the lazy-loaded view-recipient module into the main bundle.
 */
export const AUTHORIZER_PUBLIC_PATH = '/merchant/transactions/view-recipients';

/** Absolute prefix, matched with startsWith() so no other URL can slip in. */
export const AUTHORIZER_PUBLIC_URL = `${environment.API_URL3}${AUTHORIZER_PUBLIC_PATH}`;
